import { fromJS } from 'immutable';
import * as constants from '../constants';
import { propOr, prop, flatten } from 'ramda';

const initialState = fromJS({
  loadingMM: false,
  savingMedia: false,
  uploadMediaDialog: false,
  documentType: '',
  media: [],
  selectedFiles: [],
  previewDialog: false,
  hovering: false,
  filterByMediaType: 'All File Types',
  filteredMedia: [],
  uploadingFile: false,
  selectedFileIndex: 0,
  managingTags: false,
  tagsStep: 1,
  tags: [],
  searchField: '',
});

export default function marketingMaterials(state = initialState, { type, payload }) {
  switch (type) {
    case constants.GETTING_MARKETING_MATERIALS:
      return state.set('loadingMM', true);
    case constants.GOT_MARKETING_MATERIALS:
      return state.set('loadingMM', false)
                  .set('locations', fromJS(payload.locations))
                  .set('locationTags', fromJS(propOr([], 'locations', payload).map(loc => ({ id: prop('id', loc), name: prop('name', loc) }))))
                  .set('productTags', fromJS(flatten(propOr([], 'locations', payload).map(loc => propOr([], 'products', loc)))))
                  .set('media', fromJS(payload.media));
    case constants.UPDATE_MM_PROP:
      return state.merge(fromJS(payload));
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/marketing-materials/reducers/main-reducer.js